var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 9.33268V7.00279C11.375 6.13572 11.375 5.70217 11.2259 5.30537C11.0768 4.90857 10.7913 4.5823 10.2203 3.92976L9.33333 2.91602H4.66667L3.77964 3.92976C3.20867 4.5823 2.92319 4.90857 2.77409 5.30537C2.625 5.70217 2.625 6.13572 2.625 7.00279V9.33268C2.625 10.9826 2.625 11.8075 3.13756 12.3201C3.65013 12.8327 4.47508 12.8327 6.125 12.8327H7.875C9.5249 12.8327 10.3498 12.8327 10.8624 12.3201C11.375 11.8075 11.375 10.9826 11.375 9.33268Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54297 9.14782C5.54297 9.86497 6.62441 10.4529 7.66193 10.1233C8.6995 9.79357 8.54696 8.82215 8.19498 8.44065C7.84299 8.05921 7.32505 8.12314 6.73291 8.09316C5.40223 8.02567 5.30829 6.7498 6.38571 6.24504C7.17613 5.87468 8.19008 6.34963 8.30686 6.99935M6.98439 5.54102V6.11134M6.98439 10.3362V10.791",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 1.16602H9.625C9.89677 1.16602 10.0327 1.16602 10.1399 1.21042C10.2828 1.26962 10.3964 1.38318 10.4556 1.52612C10.5 1.63332 10.5 1.76922 10.5 2.04102C10.5 2.31281 10.5 2.44871 10.4556 2.55591C10.3964 2.69885 10.2828 2.81241 10.1399 2.87161C10.0327 2.91602 9.89677 2.91602 9.625 2.91602H4.375C4.1032 2.91602 3.9673 2.91602 3.8601 2.87161C3.71717 2.81241 3.60361 2.69885 3.5444 2.55591C3.5 2.44871 3.5 2.31281 3.5 2.04102C3.5 1.76922 3.5 1.63332 3.5444 1.52612C3.60361 1.38318 3.71717 1.26962 3.8601 1.21042C3.9673 1.16602 4.1032 1.16602 4.375 1.16602Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskIconSelected);
export default __webpack_public_path__ + "static/media/riskIconSelected.85997fbc7e4b48ff395e3426b2bd2c49.svg";
export { ForwardRef as ReactComponent };